import { baseClient } from '../common';
import { CreatePreferenceModel } from './create-preference.model';
import { PreferenceModel } from './preference.model';

const apiUrl = `/api/preferences`;

export const preferenceClient = {
  get: (preferenceKey: string): Promise<PreferenceModel | undefined> => {
    return baseClient.get<PreferenceModel>(`${apiUrl}/${preferenceKey}`);
  },

  set: (
    preferenceKey: string,
    model: CreatePreferenceModel,
  ): Promise<PreferenceModel> => {
    return baseClient.body<CreatePreferenceModel, PreferenceModel>({
      body: model,
      method: 'PUT',
      url: `${apiUrl}/${preferenceKey}`,
    });
  },
};
